import { RedlineSpan } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function RedlineSpanDemo() {
  return (
    <Section
      id="redline-span"
      title="RedlineSpan"
      description="Inline span for tracked-changes / suggestion / comment-anchor marks inside a document. Renders as a <span> (or asChild onto the consumer's own inline element) and flows with the surrounding text - no block shift. Reads the diff token set (--ins / --del) plus --warning for the comment anchor. Variants signal whether a change is already accepted (insertion / deletion) or pending judgement (suggestion, dotted), with suggestionId / editId surfaced as data attributes for click delegation."
    >
      <VariantBlock label="Variants" caption="insertion, deletion (struck through), suggestion (dotted, pending), comment anchor (amber)">
        <div className="flex flex-wrap items-center gap-3 text-sm">
          <RedlineSpan variant="insertion">added clause</RedlineSpan>
          <RedlineSpan variant="deletion">removed clause</RedlineSpan>
          <RedlineSpan variant="suggestion" suggestionId="sug-1">
            AI proposal
          </RedlineSpan>
          <RedlineSpan variant="comment-anchor" editId="edit-1">
            see comment
          </RedlineSpan>
        </div>
      </VariantBlock>

      <VariantBlock label="Inline sentence" caption="unchanged copy is plain; only the edits are marked, flowing with the text">
        <p className="max-w-prose text-sm leading-7">
          The agreement <RedlineSpan variant="deletion">may</RedlineSpan>{" "}
          <RedlineSpan variant="insertion">shall</RedlineSpan> be governed by the laws of the{" "}
          <RedlineSpan variant="suggestion" suggestionId="sug-2">
            State of Delaware
          </RedlineSpan>
          , and any{" "}
          <RedlineSpan variant="comment-anchor" editId="edit-2">
            dispute
          </RedlineSpan>{" "}
          arising under it remains subject to arbitration.
        </p>
      </VariantBlock>

      <VariantBlock label="asChild" caption="merges the variant classes onto the consumer's own inline element (here an <em>)">
        <p className="text-sm">
          Effective immediately:{" "}
          <RedlineSpan asChild variant="insertion">
            <em>all parties consent</em>
          </RedlineSpan>
          .
        </p>
      </VariantBlock>
    </Section>
  );
}
